import {removeTask} from "@project/sdk/admin";
import {mutationOptions} from "@tanstack/react-query";

import {userMutationKeys} from "../../../../user-keys";

/**
 * Mutation option factory for removing a task from a user.
 */
export function removeTaskMutationOptions() {
  return mutationOptions({
    mutationFn: ({userId, taskId}: {userId: string; taskId: string}) => removeTask(userId, taskId),
    mutationKey: userMutationKeys.removeTask(),
  });
}
